import { useEffect } from 'react';
import { useFlag } from '@alchemer/unleash';
import { FEATURE_FLAGS } from '@/config/features';
import { useBoundStore } from '@/store';
import {
  altDatasetTableAnswerIds,
  altSourceTableAnswerIds,
  defaultDatasetTableAnswerIds,
  defaultSourceTableAnswerIds,
} from '@/store/slices/createThoughtspotSlice';

const hasAltIds = Object.values(altSourceTableAnswerIds).some(Boolean);

export function useThoughtspotAnswerIds() {
  const useAltIds = useFlag(FEATURE_FLAGS.DOCUMENT_TYPE);
  const setSourceTableAnswerIds = useBoundStore((s) => s.setSourceTableAnswerIds);
  const setDatasetTableAnswerIds = useBoundStore((s) => s.setDatasetTableAnswerIds);

  useEffect(() => {
    if (useAltIds && !hasAltIds) {
      console.warn('DOCUMENT_TYPE flag is enabled but alt answer IDs are not configured');
      return;
    }
    setSourceTableAnswerIds(useAltIds ? altSourceTableAnswerIds : defaultSourceTableAnswerIds);
    setDatasetTableAnswerIds(useAltIds ? altDatasetTableAnswerIds : defaultDatasetTableAnswerIds);
  }, [useAltIds, setSourceTableAnswerIds, setDatasetTableAnswerIds]);
}
